import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, Divider, Popconfirm } from "antd";
import restaurantSchemeAction from "../../../../redux/restaurantSchema/actions";
import reservationsActions from "../../../../redux/reservations/actions";
import ReservationListCards from "../ReservationListCards";
import CloseButton from "../../../Common/CloseButton/CloseButton";
import "./index.css";

const { busyOrFreeTable } = restaurantSchemeAction;
const { editReservation } = reservationsActions;

const MakeBusyOrFreeTable = ({ clickedTable, setClickedTable }) => {
  const dispatch = useDispatch();
  const { reservations } = useSelector(
    (state) => state.restaurantReservationsReducer
  );

  const handleOnClose = () => {
    setClickedTable();
  };

  const clickedTableId = clickedTable?.[0]?.touchSaleTableId;

  const futureReservations = reservations.filter((reservation) => {
    if (reservation.status === 1) {
      return (
        clickedTableId !== null &&
        reservation.touchSaleTables.some(
          (table) => table.touchSaleTableId === clickedTableId
        )
      );
    }
    return false;
  });

  const seatedReservations = reservations
    .filter((reservation) => {
      if (reservation.status === 2) {
        return (
          clickedTableId !== null &&
          reservation.touchSaleTables.some(
            (table) => table.touchSaleTableId === clickedTableId
          )
        );
      }
      return false;
    })
    .sort((a, b) => {
      return a.reservationTime.localeCompare(b.reservationTime);
    });

  const seatedReservationCount = reservations.filter((reservation) => {
    return reservation.status === 2;
  });

  const hasReservationWithTouchSaleTableId = (
    reservations,
    touchSaleTableId
  ) => {
    // Find if we have reservation or only table is marked as busy
    return reservations.some((reservation) =>
      reservation.touchSaleTables.some(
        (table) => table.touchSaleTableId === touchSaleTableId
      )
    );
  };

  const handleAction = () => {
    if (
      clickedTable &&
      hasReservationWithTouchSaleTableId(
        seatedReservationCount,
        clickedTable[0]?.touchSaleTableId
      )
    ) {
      dispatch(
        editReservation({
          guestsCount: seatedReservations[0].guestsCount,
          regionId: seatedReservations[0].regionId,
          duration: seatedReservations[0].duration,
          reservationTime: seatedReservations[0].reservationTime,
          reservationDate: seatedReservations[0].reservationDate,
          name: seatedReservations[0].name,
          phone: seatedReservations[0].phone,
          note: seatedReservations[0].note,
          organizationId: parseInt(localStorage.getItem("organizationId")),
          TouchSaleTablesIds: seatedReservations[0].touchSaleTables?.map(
            (obj) => obj.touchSaleTableId
          ),
          ReservationId: seatedReservations[0].reservationId,
          status: 3,
        })
      );
    }
    dispatch(
      busyOrFreeTable({
        busy: !clickedTable[0].busy,
        regionId: clickedTable[0].regionId,
        touchSaleTableId: clickedTable[0].touchSaleTableId,
        organizationId: parseInt(localStorage.getItem("organizationId")),
      })
    );
  };

  function formatMinutesToTime(minutes) {
    if (minutes < 60) {
      return `${minutes} минути`;
    } else if (minutes === 60) {
      return `1 час`;
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `${hours} час ${remainingMinutes} минути`;
    }
  }

  return (
    <Modal
      closeIcon={<CloseButton />}
      className="reservation-busy-or-free-modal"
      open={clickedTable && clickedTable.length > 0}
      title={
        <div className="reservation-busy-or-free-modal-title-footer">
          Маса - {clickedTable && clickedTable[0]?.tableName}
        </div>
      }
      width="320px"
      okText="Освободи"
      cancelText="Затвори"
      onCancel={handleOnClose}
      footer={[
        <div
          className="reservation-busy-or-free-modal-title-footer reservation-busy-or-free-modal-footer-btn-container"
          key="footer"
        >
          <Popconfirm
            title={
              clickedTable && clickedTable[0]?.busy
                ? "Сигурни ли сте, че искате да освободите тази маса?"
                : "Сигурни ли сте, че искате да настаните без резервация?"
            }
            onConfirm={() => {
              handleAction();
              handleOnClose();
            }}
            placement="bottom"
            okText="Да"
            cancelText="Не"
          >
            <Button id="reservation-busy-or-free-modal-footer-btn">
              {clickedTable && clickedTable[0]?.busy
                ? "Освободи"
                : "Настани без резервация"}
            </Button>
          </Popconfirm>
        </div>,
      ]}
    >
      {clickedTable && clickedTable[0]?.tableOpenDurationInMinutes && (
        <p className="reservation-busy-or-free-modal-tableOpenDurationInMinutes">
          {`Масата е заета от ${formatMinutesToTime(
            clickedTable[0]?.tableOpenDurationInMinutes
          )}`}
        </p>
      )}
      {futureReservations.length !== 0 && (
        <>
          <Divider
            id="reservation-busy-or-free-modal-reservation-title"
            orientation="left"
          >
            <span>Предстоящи резервации</span>
          </Divider>

          <ReservationListCards data={futureReservations} />
        </>
      )}
      {seatedReservations.length !== 0 && (
        <>
          <Divider
            id="reservation-busy-or-free-modal-reservation-title"
            orientation="left"
          >
            <span>Настанени резервации</span>
          </Divider>

          <ReservationListCards data={seatedReservations} />
        </>
      )}
    </Modal>
  );
};

export default MakeBusyOrFreeTable;
